import {createSelector} from 'reselect';
import props from '../../../props';

export default createSelector(
    props.vip20.bonuses.random_boost,
    props.vip20.level_preset,
    (bonus, level_preset) => {
        return {
            bonus,
            level_preset
        }
    }
)